import { IconProps } from "./";
import Icon from "./assets/presentation_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Presentation(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
